import request from '../request'

//获取自己的志愿列表
export function add(params) {
  return request({ url: '/api/VolunteerResult/add',method: 'post',data: params})
}
//获取自己的志愿列表
export function del(params) {
  return request({ url: '/api/VolunteerResult/delete',method: 'post',data: params})
}
//获取自己的志愿列表
export function updateAll(params) {
  return request({ url: '/api/VolunteerResult/updateAll',method: 'post',data: params})
}
//获取自己的志愿列表
export function updateExt(params) {
  return request({ url: '/api/VolunteerResult/updateExt',method: 'post',data: params})
}
//根据院校代码和专业代码进行移除
export function codeDelete(params) {
  return request({ url: '/api/VolunteerResult/codeDelete',method: 'post',data: params})
}




// WEBPACK FOOTER //
// ./src/api/gw/volunteerresult.js